import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "authLayout__rightSide forgotPwdView" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "找回密码", -1)
const _hoisted_3 = { class: "forgotPwdView__ortherControl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_LockOutlined = _resolveComponent("LockOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      ref: "formRef",
      class: "forgotPwdView__form",
      model: _ctx.formData,
      rules: _ctx.rules,
      onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_a_form_item, {
          name: "mobile",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formData.mobile,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.mobile) = $event)),
              size: "large",
              type: "text",
              placeholder: "手机号",
              maxlength: 11
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_app_icon, {
                  type: "mobile",
                  style: _normalizeStyle({ color: 'rgba(0, 0, 0, 0.25)' }),
                  size: "18px"
                }, null, 8, ["style"])
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          name: "verificationCode",
          required: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formData.verificationCode,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.verificationCode) = $event)),
              class: "forgotPwdView__code",
              size: "large",
              type: "text",
              autocomplete: "false",
              placeholder: "验证码",
              maxlength: 6
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_LockOutlined, {
                  style: _normalizeStyle({ color: 'rgba(0, 0, 0, 0.25)' })
                }, null, 8, ["style"])
              ]),
              suffix: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "link",
                  disabled: _ctx.codeSending || _ctx.sendCounting,
                  onClick: _ctx.onSendCaptcha
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.sendText), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          name: "saasLoginPassword",
          required: "",
          help: "密码8-20位，包含字母、数字、符号至少两种"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formData.saasLoginPassword,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.saasLoginPassword) = $event)),
              size: "large",
              type: _ctx.showPwd ? 'text' : 'password',
              autocomplete: "false",
              placeholder: "设置密码",
              maxlength: 20
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_LockOutlined, {
                  style: _normalizeStyle({ color: 'rgba(0, 0, 0, 0.25)' })
                }, null, 8, ["style"])
              ]),
              suffix: _withCtx(() => [
                _createVNode(_component_app_icon, {
                  type: _ctx.eyeType,
                  size: 16,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPwd = !_ctx.showPwd))
                }, null, 8, ["type"])
              ]),
              _: 1
            }, 8, ["value", "type"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          size: "large",
          type: "primary",
          class: "login-button",
          loading: _ctx.submiting,
          disabled: _ctx.submiting,
          onClick: _ctx.onSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode("登录")
          ]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: { name: 'auth.login_by_pwd' },
            class: "forge-password"
          }, {
            default: _withCtx(() => [
              _createTextVNode("密码登录")
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, {
            to: { name: 'auth.login_by_code' },
            class: "forge-password"
          }, {
            default: _withCtx(() => [
              _createTextVNode("验证码登录")
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules", "onSubmit"])
  ]))
}